import Divider from "@components/general/Divider";
import { renderLoading } from "@pages/BoardingPass";
import Translate from "@service/Translate";
import { FC } from "react";
import { ITopicItem } from "./AgendaTopic";

interface ISmallViewTopicsItemProps extends ITopicItem {
}

const SmallViewTopicsItem: FC<ISmallViewTopicsItemProps> = ({
    displayText,
    durationTime,
    presenter,
    rangeOfTopic,
    loading,
    first,
    last
}) => {

    const { tr } = Translate;

    return <>
        <div className={`row-item-small${first ? " first" : ""}${last ? " last" : ""}`}>
            <div className="desc">
                {loading ? renderLoading().longStringBox : displayText}
            </div>
            <div className="row properties flex">
                <div className="col-1-3 cell">
                    <div className="property-container">
                        {rangeOfTopic && <div className="title">
                            {loading ? renderLoading().stringBox : tr("agenda_date")}
                        </div>}
                        <div className="value">
                            {loading ? renderLoading().stringBox : rangeOfTopic}
                        </div>
                    </div>
                </div>
                <div className="col-1-3 cell">
                    <div className="property-container">
                        {durationTime && <div className="title">
                            {loading ? renderLoading().stringBox : tr("duration_time")}
                        </div>}
                        <div className="value">
                            {loading ? renderLoading().stringBox : durationTime}
                        </div>
                    </div>
                </div>
                <div className="col-1-3 cell flex-grow">
                    <div className="property-container">
                        {presenter && <div className="title">
                            {loading ? renderLoading().stringBox : tr("presenter")}
                        </div>}
                        <div className="value">
                            {loading ? renderLoading().stringBox : presenter}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Divider
            mode="perforation"
            orientation="horizontal"
        />
    </>
};

export default SmallViewTopicsItem;
